import {
  ResponsiveContainer, BarChart, LineChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid,
} from 'recharts';
import { fmtKc } from './k2utils';

const kTick = (v) => `${Math.round(v / 1000)} tis.`;

export const K2Chart = ({ data, series, type, testId }) => {
  const Chart = type === 'line' ? LineChart : BarChart;
  return (
    <div className="h-[360px]" data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <Chart data={data} margin={{ top: 10, right: 16, left: 8, bottom: 0 }} {...(type === 'line' ? {} : { stackOffset: 'sign' })}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
          <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#57534E' }} />
          <YAxis tickFormatter={kTick} tick={{ fontSize: 11, fill: '#57534E' }} width={70} />
          <Tooltip formatter={(v) => fmtKc(v)} />
          <Legend />
          {series.map((s) => (type === 'line' ? (
            <Line key={s.key} dataKey={s.key} name={s.name} stroke={s.color} strokeWidth={2}
              strokeDasharray={s.dashed ? '5 4' : undefined} dot={{ r: 2 }} />
          ) : (
            <Bar key={s.key} dataKey={s.key} name={s.name} fill={s.color} stackId={s.stack} />
          )))}
        </Chart>
      </ResponsiveContainer>
    </div>
  );
};
